<environment-notice />
<router-outlet></router-outlet>
